import { KlarnaKosmaFlow } from '~/hooks/useKlarnaFlow/types';
import {
  KlarnaKosmaAction,
  UPDATE_TRANSACTION_FLOW,
} from '~/store/types/klarnaKosmaTypes';
import {
  apiInitKlarnaKosmaTransactions,
  apiStoreKlarnaKosmaTransactions,
} from '~/services/api/klarnaKosma';
import { GlobalErrorType } from '~/enums';
import { toggleGlobalErrorOn } from '../slices/globalError.slice';
import { logToSentry } from '~/helpers/loggers.helper';
import { AppDispatch, GetStateFunc } from '..';

export const updateTransactionFlow = (
  data: KlarnaKosmaFlow
): KlarnaKosmaAction => ({
  type: UPDATE_TRANSACTION_FLOW,
  payload: data,
});

export const processKlarnaKosmaTransactionFlow = (
  organizationNumber: string,
  clientId: number,
  applicationUuid?: string
) => async (dispatch: AppDispatch, getState: GetStateFunc) => {
  const {
    intl: { language, market },
  } = getState();
  dispatch(updateTransactionFlow({ status: 'inProgress' }));

  try {
    const response = await apiInitKlarnaKosmaTransactions(
      market,
      language,
      clientId
    );

    const {
      client_token: clientToken,
      session_id: sessionId,
      flow_id: flowId,
    } = response.data;

    window.XS2A.startFlow(clientToken, {
      onFinished: async () => {
        try {
          dispatch(updateTransactionFlow({ status: 'completed' }));
          await apiStoreKlarnaKosmaTransactions(
            market,
            sessionId,
            flowId,
            organizationNumber,
            clientId,
            applicationUuid
          );
        } catch (err) {
          logToSentry(err, 'apiStoreKlarnaKosmaTransactions', {
            organizationNumber,
          });
        }
      },
      onError: (err) => {
        logToSentry(err, 'processKlarnaKosmaTransactionFlow flow', {
          organizationNumber,
        });
        dispatch(toggleGlobalErrorOn(GlobalErrorType.API_FAILURE));
        dispatch(updateTransactionFlow({ status: 'error', error: err }));
      },
      onAbort: () => {
        dispatch(updateTransactionFlow({ status: 'idle' }));
      },
    });
  } catch (err) {
    logToSentry(err, 'apiInitKlarnaKosmaTransactions', {
      organizationNumber,
    });
    dispatch(toggleGlobalErrorOn(GlobalErrorType.API_FAILURE));
    dispatch(updateTransactionFlow({ status: 'error', error: err }));
  }
};
